<template>
  <sfs-form-modal
    :id="modalId"
    @on-hide="resetFormData"
    title="Edit Charge"
  >
    <recurring-charge-form
      :new-form="false"
      :frequency-options="frequencyOptions"
      v-bind="value"
      @on-submit="update"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import RecurringChargeForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RecurringChargeEditModal',
  mixins: [formModalMixin],
  components: {
    RecurringChargeForm,
  },
  props: {
    value: Object,
    frequencyOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalId: `recurring-charge-${this.value.id}-edit-modal`,
    };
  },
  methods: {
    update(data, handleUpdate) {
      handleUpdate(this.$recurringChargesAPI.update(this.value.id, data));
    },
    onSave(recurringCharge) {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save', recurringCharge);
    },
  },
};
</script>
